<template>
  <div class="container">
    <Loading v-show="pageLoading" />
    <div class="width_wrap">
      <MyPageSidebar />
      <div class="body_content sub">
        <div style="height: auto">
          <n-space vertical>
            <NCard
              style="
                margin-top: 20px;
                margin-left: 80px;
                border: 0px;
                min-width: 800px;
                max-width: 1000px;
              "
            >
              <n-space item-style="display: flex;" align="center">
                <div style="font-size: 20px; font-weight: bold">
                  진단 정보 등록
                </div>
              </n-space>
              <div class="content_delimiter_line"></div>
              <Loading v-if="pageLoading" />
              <div v-else-if="formModel.SK" class="body_content">
                <n-descriptions
                  label-placement="left"
                  bordered
                  :column="2"
                  size="small"
                  title="진단 기본 정보"
                >
                  <n-descriptions-item label="기관명" :span="3">{{
                    formModel.client?.name || "N/A"
                  }}</n-descriptions-item>
                  <n-descriptions-item label="상태">{{
                    getOrderStatusString(formModel.status)
                  }}</n-descriptions-item>
                  <n-descriptions-item label="생성일">
                    {{
                      formModel.createdDate
                        ? common.getYYYYMMDD2(
                            new Date(Number(formModel.createdDate))
                          )
                        : "N/A"
                    }}
                  </n-descriptions-item>
                </n-descriptions>

                <div
                  v-if="formModel.products && formModel.products.length > 0"
                  style="margin-top: 30px"
                >
                  <h3
                    class="form-section-title"
                    style="border-bottom: none; margin-bottom: 10px"
                  >
                    진단 목록
                  </h3>
                  <template
                    v-for="(productView, displayIndex) in displayedProducts"
                    :key="productView.prod_id"
                  >
                    <div class="product-item-card">
                      <n-descriptions
                        label-placement="left"
                        bordered
                        :column="3"
                        size="small"
                      >
                        <template #header>
                          진단 {{ displayIndex + 1 }}: {{ productView.name }}
                        </template>
                        <n-descriptions-item label="수량" class="quantity-item">
                          {{ productView.quantity }}
                        </n-descriptions-item>
                        <n-descriptions-item label="비고" :span="2">
                          {{ productView.notes || "N/A" }}
                        </n-descriptions-item>
                        <!-- 학급 정보 입력 섹션 -->
                      </n-descriptions>
                      <div class="class-info-section">
                        <!-- 제목과 입력 컨트롤을 한 줄에 배치하기 위한 div -->
                        <div
                          style="
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            margin-bottom: 15px;
                          "
                        >
                          <h4 class="class-info-title" style="margin-bottom: 0">
                            {{
                              productView.type === "putt_u" ||
                              productView.type === "tec"
                                ? "학과 정보"
                                : "학급 정보"
                            }}
                          </h4>
                          <n-space>
                            <!-- 입력 필드와 버튼을 그룹화 -->
                            <n-form-item
                              label-placement="left"
                              :label="
                                productView.type === 'putt_u' ||
                                productView.type === 'tec'
                                  ? '학과 수'
                                  : '학급 수'
                              "
                              :show-feedback="false"
                              style="margin-bottom: 0"
                            >
                              <n-input-number
                                v-model:value="productEntries[productView.originalIndex]!.classCountToCreate"
                                :min="1"
                                :placeholder="
                                  productView.type === 'putt_u' ||
                                  productView.type === 'tec'
                                    ? '학과 수'
                                    : '학급 수'
                                "
                              />
                            </n-form-item>
                            <n-button
                              type="info"
                              @click="
                                createClassForms(productView.originalIndex)
                              "
                              >학급 생성</n-button
                            >
                          </n-space>
                        </div>
                        <div
                          v-if="
                            productEntries[productView.originalIndex]
                              .projects &&
                            productEntries[productView.originalIndex].projects
                              .length > 0
                          "
                        >
                          <div
                            v-for="(classItem, classIdx) in productEntries[
                              productView.originalIndex
                            ].projects"
                            :key="classIdx"
                            class="class-entry"
                          >
                            <!-- 각 학급별 폼 -->
                            <n-form
                              :ref="
                                (el) =>
                                  (classFormsRef[productView.originalIndex][
                                    classIdx
                                  ] = el)
                              "
                              :model="classItem"
                              :rules="
                                classFormRules(
                                  productView.originalIndex,
                                  classIdx
                                )
                              "
                              label-placement="top"
                            >
                              <div class="class-header">
                                <!-- 학급/학과 제목 및 삭제 버튼 -->
                                <h4>
                                  {{
                                    productView.type === "putt_u" ||
                                    productView.type === "tec"
                                      ? "학과"
                                      : "학급"
                                  }}
                                  {{ classIdx + 1 }} 정보
                                </h4>

                                <!-- 담당자 지정/변경 영역 (필수 검증 지원) -->
                                <n-form-item
                                  :show-label="false"
                                  :show-feedback="false"
                                  path="email"
                                  style="margin: 0 0 0 20px;"
                                >
                                  <div style="display: flex; align-items: center; gap: 8px;">
                                    <n-button
                                      :type="classItem.email ? 'info' : 'error'"
                                      size="small"
                                      :ghost="!!classItem.email"
                                      @click="openManagerSelectModal(productView.originalIndex, classIdx)"
                                    >
                                      {{ classItem.email ? '담당자 변경' : '담당자 지정' }}
                                    </n-button>
                                    <span v-if="classItem.email" style="font-size: 14px; color: #555; background-color: #eef2ff; padding: 4px 10px; border-radius: 4px; border: 1px solid #e0e7ff; display: inline-flex; align-items: center; gap: 6px; line-height: 1;">
                                      <strong>이름:</strong> {{ classItem.manager_name }} | 
                                      <strong>이메일:</strong> {{ classItem.email }} | 
                                      <strong>역할:</strong> {{ classItem.manager_role || '-' }} | 
                                      <strong>직책:</strong> {{ classItem.manager_position || '-' }}
                                    </span>
                                    <span v-else style="color: #d03050; font-size: 13px; display: inline-flex; align-items: center; gap: 4px; font-weight: 600;">
                                      <n-icon size="16"><WarningOutline /></n-icon> 담당자 지정이 필요합니다.
                                    </span>
                                  </div>
                                </n-form-item>

                                <n-button
                                  type="error"
                                  ghost
                                  size="small"
                                  @click="
                                    deleteClassForm(
                                      productView.originalIndex,
                                      classIdx
                                    )
                                  "
                                  style="margin-left: auto"
                                >
                                  학급 삭제
                                </n-button>
                              </div>
                              <!-- 대학/일반용 그리드 -->
                              <n-grid
                                v-if="productView.type === 'putt_u' || productView.type === 'tec'"
                                :cols="12"
                                :x-gap="12"
                              >
                                <n-form-item-gi
                                  label-placement="left"
                                  :label="`전공`"
                                  :span="6"
                                  path="major"
                                >
                                  <n-input
                                    v-model:value="classItem.major"
                                    :placeholder="'학과명 (예: 컴퓨터공학과)'"
                                  />
                                </n-form-item-gi>
                                <n-form-item-gi
                                  label="학생 수"
                                  label-placement="left"
                                  label-width="100px"
                                  :span="6"
                                  path="studentCountToCreate"
                                >
                                  <n-input-number
                                    v-model:value="classItem.studentCountToCreate"
                                    :min="1"
                                    placeholder="학급(학과)의 총 학생 수"
                                    style="width: 100%"
                                  />
                                </n-form-item-gi>
                                <n-form-item-gi
                                  label-placement="left"
                                  label-width="90px"
                                  :span="4"
                                  label="진단 시작일"
                                  path="start_target_date"
                                >
                                  <n-date-picker
                                    v-model:formatted-value="classItem.start_target_date"
                                    value-format="yyyy-MM-dd"
                                    type="date"
                                    placeholder="시작일 선택"
                                    style="width: 100%"
                                  />
                                </n-form-item-gi>
                                <n-form-item-gi
                                  label-placement="left"
                                  label-width="90px"
                                  :span="4"
                                  label="진단 종료일"
                                  path="end_target_date"
                                >
                                  <n-date-picker
                                    v-model:formatted-value="classItem.end_target_date"
                                    value-format="yyyy-MM-dd"
                                    type="date"
                                    placeholder="종료일 선택"
                                    style="width: 100%"
                                  />
                                </n-form-item-gi>
                              </n-grid>

                              <!-- 초중고용 그리드 -->
                              <n-grid
                                v-else
                                :cols="12"
                                :x-gap="12"
                              >
                                <n-form-item-gi
                                  label-placement="left"
                                  label-width="90px"
                                  :span="4"
                                  :label="`학년`"
                                  path="grade"
                                >
                                  <n-input
                                    v-model:value="classItem.grade"
                                    placeholder="학년 (예: 1)"
                                    style="width: 100%"
                                  />
                                </n-form-item-gi>
                                <n-form-item-gi
                                  label-placement="left"
                                  label-width="90px"
                                  :span="4"
                                  :label="`반`"
                                  path="class"
                                >
                                  <n-input
                                    v-model:value="classItem.class"
                                    placeholder="반 (예: 1A)"
                                    style="width: 100%"
                                  />
                                </n-form-item-gi>
                                <n-form-item-gi
                                  label="학생 수"
                                  label-placement="left"
                                  label-width="100px"
                                  :span="4"
                                  path="studentCountToCreate"
                                >
                                  <n-input-number
                                    v-model:value="classItem.studentCountToCreate"
                                    :min="1"
                                    placeholder="학급(학과)의 총 학생 수"
                                    style="width: 100%"
                                  />
                                </n-form-item-gi>
                                <n-form-item-gi
                                  label-placement="left"
                                  label-width="90px"
                                  :span="4"
                                  label="진단 시작일"
                                  path="start_target_date"
                                >
                                  <n-date-picker
                                    v-model:formatted-value="classItem.start_target_date"
                                    value-format="yyyy-MM-dd"
                                    type="date"
                                    placeholder="시작일 선택"
                                    style="width: 100%"
                                  />
                                </n-form-item-gi>
                                <n-form-item-gi
                                  label-placement="left"
                                  label-width="90px"
                                  :span="4"
                                  label="진단 종료일"
                                  path="end_target_date"
                                >
                                  <n-date-picker
                                    v-model:formatted-value="classItem.end_target_date"
                                    value-format="yyyy-MM-dd"
                                    type="date"
                                    placeholder="종료일 선택"
                                    style="width: 100%"
                                  />
                                </n-form-item-gi>
                              </n-grid>
                            </n-form>
                          </div>
                        </div>
                        <div
                          v-else
                          class="class-entry"
                          style="
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            align-items: center;
                            min-height: 150px;
                          "
                        >
                          <n-icon
                            size="32"
                            color="#aaa"
                            style="margin-bottom: 10px"
                          >
                            <InformationCircleOutline />
                          </n-icon>
                          <div
                            style="
                              font-size: 16px;
                              color: #1e3a8a;
                              font-weight: 600;
                              text-align: center;
                            "
                          >
                            우측 상단의 '추가할
                            {{
                              productView.type === "putt_u" ||
                              productView.type === "tec"
                                ? "학과"
                                : "학급"
                            }}
                            수'를 입력 후 '{{
                              productView.type === "putt_u" ||
                              productView.type === "tec"
                                ? "학과"
                                : "학급"
                            }}
                            생성' 버튼을 눌러주세요.<br />
                            생성된 각
                            {{
                              productView.type === "putt_u" ||
                              productView.type === "tec"
                                ? "학과"
                                : "학급"
                            }}에 진단 인원을 입력하여 진행할 수 있습니다.
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
                <div
                  v-else
                  style="margin-top: 20px; text-align: center; color: #888"
                >
                  견적에 포함된 상품이 없습니다.
                </div>
              </div>
              <div
                v-else
                style="text-align: center; padding: 20px; color: #888"
              >
                견적 정보를 불러오지 못했습니다.
              </div>
            </NCard>
            <!-- 최하단 버튼 영역 -->
            <div
              v-if="
                formModel.SK &&
                formModel.products &&
                formModel.products.length > 0
              "
              style="margin-top: 0px; margin-bottom: 10px; text-align: right"
            >
              <n-button
                type="tertiary"
                @click="handleCancel"
                style="margin-right: 12px"
              >
                취소
              </n-button>
              <n-button
                type="default"
                @click="handleTemporarySave"
                :loading="isTemporarySaving"
                style="margin-right: 12px"
              >
                임시저장
              </n-button>
              <n-button
                type="primary"
                @click="handleComplete"
                :loading="isStartingComplete"
              >
                작성완료
              </n-button>
            </div>
          </n-space>
        </div>
      </div>
    </div>
    <!-- 담당자 지정 모달 -->
    <n-modal
      v-model:show="isManagerModalOpen"
      preset="card"
      title="담당자 지정"
      style="width: 700px; max-width: 90%"
      :bordered="false"
    >
      <n-space vertical :size="12">
        <n-space align="center" justify="space-between">
          <n-input
            v-model:value="memberSearchQuery"
            placeholder="이름 또는 이메일 검색"
            clearable
            style="width: 250px"
          />
          <n-checkbox v-model:checked="isIncludeAdmin">
            관리자 포함
          </n-checkbox>
        </n-space>
        <n-data-table
          :loading="loadingMembers"
          :columns="memberTableColumns"
          :data="filteredOrgMembers"
          :pagination="{ pageSize: 5 }"
          :row-key="(row) => row.SK"
        />
      </n-space>
    </n-modal>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, computed, watch, nextTick, h } from "vue";
import MyPageSidebar from "@/views/member/MypageSidebar.vue";
import Banner from "@/components/Banner.vue";
import { USER_ROUTES } from "@/assets/route_constants.ts";
import { useRouter, useRoute } from "vue-router";
import {
  NSpace,
  NCard,
  NForm,
  NFormItem,
  NInput,
  NButton,
  NDatePicker,
  NSelect,
  NRadioGroup,
  NRadioButton,
  FormInst,
  FormRules,
  NDescriptions,
  NDescriptionsItem,
  NGrid,
  NFormItemGi,
  useMessage,
  useNotification,
  useDialog,
  NIcon,
  NInputNumber,
  NInputGroup,
  NModal,
  NDataTable,
  NCheckbox,
} from "naive-ui";
import Loading from "@/components/Loading.vue";
import { getCallable, makeCallApiParam } from "@/config/env";
import * as common from "@/assets/common/common";
import * as constant from "@/constants/constant";
import { Order, OrderItem } from "@/model/order";
import { Project } from "@/model/project";
import { Examinee } from "@/model/examinee";
import { getOrderStatusString } from "@/composables/useOrderForm";
import { WarningOutline, InformationCircleOutline } from "@vicons/ionicons5";
import { useActionDialog } from "@/composables/useDialog";
const { show: showActionDialog } = useActionDialog();
const formModel = ref<Order>({
  order_id: "",
  SK: "",
  name: "",
  cc: "",
  receiver_email: "",
  client: {
    uid: "",
    name: "",
  },
  payment_method: {
    bank_date: null,
    bank_name: "",
    deposit_name: "",
    type: "",
  },
  products: [], // 견적 항목 배열
  status: "",
  totalPrice: 0,
  type: constant.orderType.BODY,
});

// 각 상품별 UI 상태 및 학급 정보를 관리하기 위한 인터페이스
interface ProjectUIData extends Partial<Project> {
  studentCountToCreate: number | null; // 사용자가 입력하는 생성할 학생 수
}

interface ProductUIData extends Partial<OrderItem> {
  classCountToCreate: number | null; // 사용자가 입력하는 생성할 학급 수
  projects: ProjectUIData[]; // 생성된 학급 정보 배열
}

const router = useRouter();
const route = useRoute();
const message = useMessage();
const notification = useNotification();
const dialog = useDialog();

const pageLoading = ref(true);

const productEntries = ref<ProductUIData[]>([]); // 각 상품별 UI 상태 및 학급 정보를 관리
const isTemporarySaving = ref(false); // 임시저장 로딩 상태
const isStartingComplete = ref(false); // 진단 시작 로딩 상태

const classFormsRef = ref<FormInst[][]>([]); // 각 상품별, 각 학급별 폼 참조 배열 (2차원 배열)
const orderName = ref<string | null>(null);

const getOrderDetailsCallable = getCallable("getOrder");
const getCallApiCallable = getCallable("callApi");
const changeOrderStatusFunc = "changeOrderStatus";

// --- 데이터 로딩 및 폼 초기화 ---
onMounted(async () => {
  pageLoading.value = true;
  const orderSKFromRoute = route.params.SK as string;

  if (!orderSKFromRoute) {
    notification.error({
      title: "오류",
      description: "견적 정보가 올바르지 않습니다. 견적 목록으로 돌아갑니다.",
      duration: 3000,
    });
    router.push({ name: USER_ROUTES.Mypage.Order.Org.Name }); // 견적 목록 라우트 이름으로 변경
    return;
  }

  formModel.value.SK = orderSKFromRoute; // formModel은 Order 타입이므로 SK 사용

  try {
    const result = await getOrderDetailsCallable({ SK: orderSKFromRoute });
    const orderData = common.getItemFromFunctionResult(result) as Order;

    if (orderData && orderData.products && orderData.products.length > 0) {
      orderName.value = orderData.name || "제목 없음";
      formModel.value = { ...orderData };

      productEntries.value = orderData.products.map(
        (productItem: OrderItem) => {
          const savedProjectsFromProduct: Project[] =
            (productItem as any).projects || [];

          const uiClasses: ProjectUIData[] = savedProjectsFromProduct.map(
            (dbProject: Project) => {
              return {
                ...dbProject,
                grade: dbProject.grade !== undefined && dbProject.grade !== null ? dbProject.grade.toString() : "",
                class: dbProject.class !== undefined && dbProject.class !== null ? dbProject.class.toString() : "",
                studentCountToCreate: dbProject.student_count,
              };
            }
          );

          return {
            ...productItem,
            classCountToCreate: 1,
            projects: uiClasses,
          };
        }
      );
      classFormsRef.value = productEntries.value.map(() => []);
    } else {
      notification.warning({
        title: "정보 없음",
        description: "해당 견적에 상품 정보가 없습니다.",
        duration: 3000,
      });
      router.push({ name: USER_ROUTES.Mypage.Order.Org.Name });
      return;
    }
  } catch (error: any) {
    console.error("견적 상세 정보 로딩 실패:", error);
    notification.error({
      title: "로딩 실패",
      description: error || "견적 정보를 불러오는 중 오류가 발생했습니다.",
      duration: 3000,
    });
    router.push({ name: USER_ROUTES.Mypage.Order.Org.Name }); // 오류 시 견적 목록으로 돌아가기
    return;
  } finally {
    pageLoading.value = false;
  }
});

// 화면에 표시될 상품 목록 (personal 상품만 필터링하고, 원본 인덱스 포함)
const displayedProducts = computed(() => {
  return formModel.value.products
    .map((product, originalIndex) => ({
      ...product,
      originalIndex, // 원본 배열에서의 인덱스
    }))
    .filter(
      (p) =>
        p.prod_id &&
        (p.prod_id.startsWith("personal") ||
          (p.prod_id.startsWith("activity") && p.type?.startsWith("putt_")))
    );
});

interface ValidationDetail {
  name: string;
  quantity: number;
  totalStudentsInClasses: number;
  classCount: number;
}

interface ValidateResult {
  hasExcess: boolean;
  insufficientDetails: ValidationDetail[];
}

function validateStudentQuantities(): ValidateResult {
  const insufficientDetails: ValidationDetail[] = [];
  let hasExcess = false;

  for (const entry of productEntries.value) {
    let projectEntry = entry as ProductUIData;
    if (
      !(
        projectEntry.prod_id.startsWith("personal") ||
        (projectEntry.prod_id.startsWith("activity") &&
          projectEntry.type?.startsWith("putt_"))
      )
    )
      continue;
    let totalStudentsInClasses = 0;
    for (const classItem of projectEntry.projects) {
      totalStudentsInClasses += classItem.studentCountToCreate || 0; // 각 학급의 학생 수를 더함
    }
    if (totalStudentsInClasses != projectEntry.quantity) {
      const resultDetails: ValidationDetail = {
        name: projectEntry.name || "상품",
        quantity: projectEntry.quantity || 0,
        totalStudentsInClasses: totalStudentsInClasses,
        classCount: projectEntry.projects.length,
      };

      if (totalStudentsInClasses > projectEntry.quantity) {
        notification.error({
          title: "수량 초과 오류",
          description: `'${projectEntry.name}'의 총 학생 수(${totalStudentsInClasses}명)가 진단 가능 수량(${projectEntry.quantity}명)을 초과했습니다.`,
          duration: 5000,
        });
        hasExcess = true;
      } else {
        insufficientDetails.push(resultDetails);
      }
    }
  }
  return { hasExcess, insufficientDetails };
}

function makePayload(): Order {
  const payload: Order = {
    SK: formModel.value.SK,
    client: formModel.value.client,
    products: productEntries.value.map((projectEntry) => {
      const { classCountToCreate, ...restOfProductItem } = projectEntry;
      return {
        ...restOfProductItem,
        projects: projectEntry.projects.map((classItem) => {
          const { studentCountToCreate, ...restOfClassItemBase } = classItem;
          let restOfClassItem: Partial<ProjectUIData> = restOfClassItemBase;

          if (classItem.type == "putt_u" || classItem.type == "tec") {
            const { num, ...filtered } = restOfClassItem as any; // num 필드 제외 (타입에 따라)
            restOfClassItem = filtered;
          } else {
            const { major, ...filtered } = restOfClassItem as any; // major 필드 제외 (타입에 따라)
            restOfClassItem = filtered;
          }
          return { ...restOfClassItem, student_count: studentCountToCreate };
        }),
      };
    }),
  };
  return payload;
}

async function handleTemporarySave() {
  isTemporarySaving.value = true;
  try {
    const payload: Order = makePayload();
    const result = await getCallApiCallable(
      makeCallApiParam(changeOrderStatusFunc, {
        status: constant.orderStatus.APPROVED_TEMP_SAVE,
        type: constant.orderType.BODY,
        data: payload,
      })
    );
    if (common.evalFunctionResult(result)) {
      message.success("임시 저장되었습니다.");
    } else {
      throw new Error(
        common.getResultError(result) || "임시 저장 중 오류가 발생했습니다."
      );
    }
  } catch (error: any) {
    console.error("임시 저장 실패:", error);
    message.error(
      common.getResultError(error) || "임시 저장 중 오류가 발생했습니다."
    );
  } finally {
    isTemporarySaving.value = false;
  }
}

async function doComplete() {
  try {
    const payload: Order = makePayload();
    const result = await getCallApiCallable(
      makeCallApiParam(changeOrderStatusFunc, {
        status: constant.orderStatus.READY,
        type: constant.orderType.BODY,
        data: payload,
      })
    );
    if (common.evalFunctionResult(result)) {
      notification.success({
        title: "성공",
        description: "정보 등록이 성공했습니다.",
        duration: 3000,
      });
      router.push({
        name: USER_ROUTES.Mypage.Order.Org.Project.Detail.Name,
        params: { SK: payload.SK },
      });
    } else {
      throw new Error(
        common.getResultError(result) || "임시 저장 중 오류가 발생했습니다."
      );
    }
  } catch (error) {
  } finally {
    isStartingComplete.value = false;
  }
}

async function handleComplete() {
  isStartingComplete.value = true;
  let allFormsValid = true;

  for (const projectForms of classFormsRef.value) {
    for (const formRef of projectForms) {
      if (formRef) {
        try {
          await formRef.validate();
        } catch (errors) {
          allFormsValid = false;
        }
      }
    }
  }

  // 담당자 미지정 학급 수동 차단 검사
  let hasMissingManager = false;
  for (const entry of productEntries.value) {
    if (entry.projects && entry.projects.length > 0) {
      for (const proj of entry.projects) {
        if (!proj.email) {
          hasMissingManager = true;
          break;
        }
      }
    }
  }

  if (!allFormsValid || hasMissingManager) {
    if (hasMissingManager) {
      message.error("담당자가 지정되지 않은 학급(학과)이 있습니다. 담당자를 모두 지정해주세요.");
    } else {
      message.error("입력값을 확인해주세요.");
    }
    isStartingComplete.value = false;
    return;
  }

  const result = validateStudentQuantities();

  if (result.hasExcess) {
    // Already notified in validation function
    isStartingComplete.value = false;
    return;
  }

  if (result.insufficientDetails.length > 0) {
    showActionDialog({
      title: "확인",
      icon: () => h(NIcon, null, { default: () => h(WarningOutline) }),
      showIcon: true,
      style: "width: 600px;", // Increase width to accommodate details
      content: () =>
        h("div", null, [
          h(
            "div",
            {
              style:
                "max-height: 300px; overflow-y: auto; margin-bottom: 15px;",
            },
            result.insufficientDetails.map((detail) =>
              h(
                "div",
                {
                  style: {
                    marginBottom: "10px",
                    backgroundColor: "#f9f9f9",
                    padding: "10px",
                    borderRadius: "5px",
                    border: "1px solid #eee",
                  },
                },
                [
                  h(
                    "div",
                    {
                      style: {
                        fontWeight: "bold",
                        marginBottom: "5px",
                        fontSize: "1.05em",
                      },
                    },
                    detail.name
                  ),
                  h("div", `■ 전체 진단 가능 수량: ${detail.quantity}명`),
                  h("div", `■ 생성한 학급(학과) 수: ${detail.classCount}개`),
                  h(
                    "div",
                    `■ 등록한 전체 학생 수: ${detail.totalStudentsInClasses}명`
                  ),
                ]
              )
            )
          ),
          h(
            "p",
            { style: { color: "red", fontWeight: "bold", fontSize: "1.1em" } },
            "진단가능 수량보다 등록한 학생 수가 작습니다."
          ),
          h("p", "미등록 학생을 확인해 주시기 바랍니다."),
          h(
            "p",
            { style: { color: "red", fontWeight: "bold", marginTop: "10px" } },
            "그래도 계속 진행 하시겠습니까?"
          ),
        ]),
      positiveText: "예",
      negativeText: "아니요",
      confirmButtonLoadingText: "처리 중...",
      onConfirm: () => {
        doComplete();
      },
      onCancel: () => {
        isStartingComplete.value = false;
      },
    });
  } else {
    doComplete();
  }
}
function handleCancel() {
  router.push({ name: USER_ROUTES.Mypage.Order.Org.Name });
}

function createClassForms(projectIndex: number) {
  const entry = productEntries.value[projectIndex];
  if (entry && entry.classCountToCreate && entry.classCountToCreate > 0) {
    // entry.projects = []; // 기존 학급 정보 초기화 (또는 필요에 따라 추가하는 로직으로 변경)
    const currentProjectCount = entry.projects.length; // 현재 학급/학과 수
    for (let i = 0; i < entry.classCountToCreate; i++) {
      const newProjectNum = currentProjectCount + i + 1;
      entry.projects.push({
        name: entry.name,
        num: newProjectNum,
        grade: "1",
        class: newProjectNum.toString(),
        type: entry.type,
        start_target_date: null,
        end_target_date: null,
        status: constant.projectStatus.PENDING,
        studentCountToCreate: 1, // 초기 학생 수는 1로 설정
      });
    }
    // 학급 폼 참조 배열 초기화 (새로 생성된 학급 수에 맞게)
    classFormsRef.value[projectIndex] = Array(entry.projects.length).fill(null);
  } else {
    message.warning("생성할 학급 수를 1 이상으로 입력해주세요.");
  }
}
// 학급 삭제 버튼 클릭 시
function deleteClassForm(projectIndex: number, classIndex: number) {
  const entry = productEntries.value[projectIndex];
  if (entry && entry.projects && entry.projects.length > classIndex) {
    entry.projects.splice(classIndex, 1);
    // 해당 학급의 폼 참조 제거
    classFormsRef.value[projectIndex].splice(classIndex, 1);
    message.success("학급이 삭제되었습니다.");
  }
}

// createExamineeForms 함수 제거
// deleteExamineeForm 함수 제거

// 학급 폼 유효성 검사 규칙 생성 함수
const classFormRules = (
  projectIndex: number,
  classIndex: number
): FormRules => {
  const rules: FormRules = {};
  rules.name = [
    {
      required: true,
      message: "학급/학과명을 입력해주세요.",
      trigger: ["input", "blur"],
    },
  ];
  rules.major = [
    {
      required: true,
      message: "전공/학과명을 입력해주세요.",
      trigger: ["input", "blur"],
    },
  ];

  // Grade and Class rules might depend on the product type
  const productType = productEntries.value[projectIndex]?.type;
  if (!(productType === "putt_u" || productType === "tec")) {
    rules.grade = [
      {
        type: "string",
        required: true,
        message: "학년을 입력해주세요.",
        trigger: ["input", "blur", "change"],
      },
    ];
    rules.class = [
      {
        type: "string",
        required: true,
        message: "반을 입력해주세요.",
        trigger: ["input", "blur", "change"],
      },
    ];
  }
  rules.email = [
    {
      required: true,
      message: "담당자를 지정해주세요.",
      trigger: "change",
    },
  ];
  rules.start_target_date = [
    {
      required: true,
      message: "진단 시작 시간을 선택해주세요.",
      trigger: "change",
    },
  ];
  rules.end_target_date = [
    {
      required: true,
      message: "진단 종료 시간을 선택해주세요.",
      trigger: "change",
    },
  ];

  // 학생 정보 관련 유효성 검사 규칙 제거
  return rules;
};

// 담당자 지정 관련 상태 및 함수
const isManagerModalOpen = ref(false);
const orgMembers = ref<any[]>([]);
const loadingMembers = ref(false);
const activeTarget = ref<{ productIndex: number; projectIndex: number } | null>(null);
const memberSearchQuery = ref("");
const isIncludeAdmin = ref(false);

const getOrgMembersCallable = getCallable("getOrgMembers");

const filteredOrgMembers = computed(() => {
  return orgMembers.value.filter((member) => {
    // 1. 관리자 포함 여부 필터
    if (!isIncludeAdmin.value && member.type === "admin") {
      return false;
    }
    // 2. 이름 또는 이메일 검색 필터
    if (memberSearchQuery.value.trim()) {
      const q = memberSearchQuery.value.toLowerCase().trim();
      const nameMatch = member.name?.toLowerCase().includes(q);
      const emailMatch = member.email?.toLowerCase().includes(q);
      return nameMatch || emailMatch;
    }
    return true;
  });
});

async function openManagerSelectModal(productIndex: number, projectIndex: number) {
  activeTarget.value = { productIndex, projectIndex };
  isManagerModalOpen.value = true;
  loadingMembers.value = true;
  orgMembers.value = [];
  memberSearchQuery.value = "";
  isIncludeAdmin.value = false;
  try {
    console.log("=== openManagerSelectModal Debug ===");
    console.log("formModel SK:", formModel.value?.SK);
    console.log("formModel client:", JSON.stringify(formModel.value?.client));
    
    const clientUid = formModel.value.client?.uid;
    let orgId = "";
    if (clientUid) {
      orgId = clientUid.includes("#") ? clientUid.split("#")[1] : clientUid;
      console.log("Case 1: Found clientUid. Selected orgId:", orgId);
    } else {
      const parts = formModel.value.SK.split("#");
      console.log("Case 2: Fallback to SK parts:", parts);
      if (parts[0] === "org" && parts[1] === "org") {
        orgId = parts[2];
      } else {
        orgId = parts[1];
      }
      console.log("Selected orgId from parts:", orgId);
    }
    
    console.log("Final orgId parameter to call API:", orgId);
    const result = await getOrgMembersCallable({ orgId });
    const list = common.getItemListFromFunctionResult(result) || [];
    orgMembers.value = list;
  } catch (error) {
    console.error("기관 멤버 조회 실패:", error);
    message.error("기관 멤버 정보를 불러오는데 실패했습니다.");
  } finally {
    loadingMembers.value = false;
  }
}

function selectManager(row: any) {
  if (activeTarget.value) {
    const { productIndex, projectIndex } = activeTarget.value;
    const project = productEntries.value[productIndex].projects[projectIndex];
    project.email = row.email;
    project.manager_name = row.name;
    project.manager_role = row.role || "";
    project.manager_position = row.position || "";
    
    project.manager_id = row.SK.split("#").pop() || "";
  }
  isManagerModalOpen.value = false;
}

function getManagerDisplayText(classItem: any) {
  if (!classItem || !classItem.email) return "";
  const parts = [];
  if (classItem.manager_name) {
    parts.push(`${classItem.manager_name} (${classItem.email})`);
  } else {
    parts.push(classItem.email);
  }
  if (classItem.manager_role) {
    parts.push(classItem.manager_role);
  }
  if (classItem.manager_position) {
    parts.push(classItem.manager_position);
  }
  return parts.join(" / ");
}

const memberTableColumns = [
  {
    title: "이름",
    key: "name",
  },
  {
    title: "이메일",
    key: "email",
  },
  {
    title: "역할",
    key: "role",
    render(row: any) {
      return row.role || "-";
    }
  },
  {
    title: "직책",
    key: "position",
    render(row: any) {
      return row.position || "-";
    }
  },
  {
    title: "구분",
    key: "type",
    render(row: any) {
      return row.type === "admin" ? "관리자" : "사용자";
    }
  },
  {
    title: "선택",
    key: "actions",
    render(row: any) {
      return h(
        NButton,
        {
          size: "small",
          type: "info",
          onClick: () => selectManager(row),
        },
        { default: () => "선택" }
      );
    },
  },
];
</script>

<style scoped>
.main_div {
  background-color: #f0f2f5;
  min-height: calc(100vh - var(--header-height, 64px));
  padding: 1px; /* 자식 마진 병합 방지 */
}

.content_delimiter_line {
  height: 1px;
  width: 100%;
  background-color: #efeff5;
  margin-top: 15px;
  margin-bottom: 25px;
}

.body_content {
  padding: 0 10px; /* 내부 컨텐츠 좌우 약간의 패딩 */
}

.form-section-title {
  font-size: 1.2em;
  font-weight: bold;
  margin-top: 30px;
  margin-bottom: 20px;
  color: #333;
  border-bottom: 2px solid #007bff; /* 섹션 구분선 강조 */
  padding-bottom: 10px;
}

.examinee-entry {
  border: 1px solid #eee;
  padding: 15px;
  margin-bottom: 15px;
  border-radius: 4px;
  background-color: #ffffff; /* 배경색을 흰색으로 변경하여 그림자 효과 강조 */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* 그림자를 조금 더 진하고 넓게 */
}
.class-entry {
  border: 1px solid #e0e0e0; /* 외곽선 색상을 약간 더 진하게 */
  padding: 15px;
  margin-bottom: 10px;
  border-radius: 4px;
  background-color: #f8f9fa;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05); /* 약간의 그림자 효과 */
}

.class-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px; /* 제목과 폼 아이템 사이 간격 */
}
.class-header h4 {
  margin: 0; /* 기본 마진 제거 */
  font-size: 1.15em; /* 제목 폰트 크기 약간 키움 */
  color: #333; /* 제목 색상 변경 */
}

.examinee-entry h4 {
  margin-top: 0;
  margin-bottom: 15px;
  color: #555;
  font-size: 1.1em;
}

.examinee-delimiter {
  height: 1px;
  background-color: #ddd;
  margin: 20px 0;
}

.project-delimiter {
  height: 2px;
  background-color: #ccc;
  margin: 40px 0;
}
.product-item-card {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 15px;
  margin-bottom: 15px;
  background-color: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}
.class-info-section {
  margin-top: 25px;
  padding-top: 20px;
  border-top: 1px solid #e0e0e0;
}
.class-info-title {
  font-size: 1.2em;
  font-weight: bold;
  margin-bottom: 15px;
  color: #444;
}

.class-delimiter {
  height: 1px;
  background-color: #ddd;
  margin: 20px 0;
}

.examinee-creation-section {
  margin-top: 20px;
  padding-top: 15px;
  border-top: 1px dashed #ccc;
}
.examinee-creation-title {
  font-size: 1.05em;
  font-weight: bold;
  margin-bottom: 15px;
  color: #555;
}
.examinee-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px; /* 학생 제목과 폼 아이템 사이 간격 */
}
.examinee-number-title {
  font-size: 1em; /* 기존 h6보다 약간 크게 조정 */
  font-weight: 600; /* 약간 더 굵게 */
  color: #333;
}
.quantity-item :deep(.n-descriptions-item-label),
.quantity-item :deep(.n-descriptions-item-content) {
  font-size: 0.85em; /* 레이블과 내용의 폰트 크기를 줄임 */
  padding-top: 6px; /* 패딩 조절 */
  padding-bottom: 6px; /* 패딩 조절 */
}

/* Naive UI 컴포넌트가 자체 스타일을 잘 가지고 있으므로,
   필요한 경우에만 추가적인 스타일을 정의합니다. */
</style>
